<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Indikator Elements Data</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/elementsdata">Element Data</Link>
                </li>
                <li v-if="parent && parent.label" class="breadcrumb-item active">
                  <Link :href="'/admin/elementsdata/' + parent.parent_id" v-text="parent.label"></Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Identitas Indikator Satu Data</h4>
                  <p class="card-title-desc mb-0">Memuat nama atau tolok indikator, satuan, dan entitas selain data. Anda juga dapat untuk menampilkan atau tidak pada halaman muka.</p>
                </div>
                <div>
                  <div class="d-flex gap-2">
                    <button type="button" class="btn btn-success" @click="form.show = true">Tambah Baru</button>
                    <div class="dropdown">
                      <a class="btn btn-default border" @click="control.show = !control.show">
                        <Icon v-if="control.show" :icon="['fa', 'chevron-up']" />
                        <Icon v-else :icon="['fa', 'chevron-down']" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <hr />

              <div v-if="control.show" class="mt-3 d-flex gap-2">
                <button :disabled="!control.selected.length" @click="addClipboard('copy')" type="button" class="btn btn-sm btn-info">Duplikat</button>
                <button :disabled="!control.selected.length" @click="addClipboard('cut')" type="button" class="btn btn-sm btn-warning">Pindah</button>
                <button :disabled="!control.clipboard.data.length" @click="storeClipboard()" type="button" class="btn btn-sm btn-primary">Tempel</button>
                <span class="text-muted pt-1">|</span>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">#</th>
                      <th>Element Data / Indikator</th>
                      <th>Satuan</th>
                      <th>Publish</th>
                      <th>Perubahan Terakhir</th>
                      <th class="text-center">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in elementsdata" :key="index" @click.stop="controlSelect(row)" :class="{ 'table-active': controlSelected(row) }">
                      <td scope="row" class="text-center">
                        <input type="checkbox" :checked="controlSelected(row)" v-if="control.show" />
                        {{ index + 1 }}
                      </td>
                      <td scope="row">
                        <Link :href="'/admin/elementsdata/' + row.id" v-text="row.label"></Link>
                        <span class="badge rounded-pill bg-info ms-2" v-if="row.child_count">{{ row.child_count }} Subdata</span>
                      </td>
                      <td scope="row">{{ row.satuan || '-' }}</td>
                      <td scope="row">{{ row.is_published == 'Y' ? 'Ya' : 'Tidak' }}</td>
                      <td scope="row">{{ new Date(row.updated_at).toLocaleString() }}</td>
                      <td scope="row" class="text-center">
                        <a @click="edit(row)" class="p-0 btn btn-sm btn-link">Edit</a> | <a @click="remove(row)" class="p-0 btn btn-sm btn-link">Hapus</a> |
                        <Link :href="'/admin/elementsdata/' + row.id" class="p-0 btn btn-sm btn-link">Buka</Link>
                      </td>
                    </tr>
                    <tr v-if="elementsdata.length == 0">
                      <td scope="row" colspan="6" class="text-center">
                        <i>Tidak ditemukan data!</i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>

  <modal :show="form.show" @close="form.show = false" :title="(form.id ? 'Ubah' : 'Tambah') + ' Indikator'" backdrop="static">
    <template #default>
      <form @submit.prevent="action" method="POST" action="">
        <div class="mb-3">
          <label for="indikator" class="form-label">Nama Indikator</label>
          <input v-model="form.label" type="text" name="label" class="form-control" id="indikator" />
        </div>
        <div class="mb-3">
          <label for="satuan" class="form-label">Satuan</label>
          <input v-model="form.satuan" type="text" name="satuan" class="form-control" id="satuan" />
        </div>
        <div class="mb-3 form-check">
          <input v-model="form.is_published" type="checkbox" class="form-check-input" id="publish" />
          <label class="form-check-label" for="publish">Publikasi</label>
        </div>
      </form>
    </template>
    <template #footer>
      <button type="button" class="btn btn-primary" @click="action">Simpan</button>
    </template>
  </modal>
</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  layout: Layout,
  components: { Modal },
  props: {
    elementsdata: Array,
    parent: Object,
  },
  data() {
    return {
      form: {
        show: false,
        id: null,
        label: '',
        satuan: '',
        is_published: false,
        parent_id: 0,
      },
      control: {
        show: false,
        selected: [],
        clipboard: {
          type: null,
          data: [],
        },
      },
    }
  },
  methods: {
    addClipboard(type) {
      if (!this.control.selected.length) return
      this.control.clipboard.type = type
      this.control.clipboard.data = []
      this.control.selected.map(r => {
        this.control.clipboard.data.push(r);
      });
    },
    storeClipboard() {
      const { data, type } = this.control.clipboard
      if (!data.length) return
      const ids = []
      data.map((r) => {
        ids.push(r.id)
      })
      switch (type) {
        case 'copy':
          this.$inertia.post(`/admin/elementsdata/${this.parent.id}/clipboard`, {
            ids,
          })
          break
        case 'cut':
          this.$inertia.put(`/admin/elementsdata/${this.parent.id}/clipboard`, {
            ids,
          })
          break
      }
    },
    controlSelected(row) {
      let selected = false
      let index = null
      this.control.selected.map((r, i) => {
        if (r.id == row.id) {
          selected = r.id
          index = i
        }
      })
      return selected ? { selected, index } : false
    },
    controlSelect(row) {
      if (!this.control.show) return
      const selected = this.controlSelected(row)
      if (selected) {
        this.control.selected.splice(selected.index, 1)
      } else {
        this.control.selected.push(row)
      }
      console.log(this.control.selected)
    },
    edit({ id, label, satuan, is_published, parent_id }) {
      this.form.id = id
      this.form.label = label
      this.form.satuan = satuan
      this.form.is_published = is_published == 'Y'
      this.parent_id = parent_id
      this.form.show = true
    },
    action() {
      if (this.parent && this.parent.id) {
        this.form.parent_id = this.parent.id
      }
      if (this.form.id) {
        this.$inertia.put('/admin/elementsdata/' + this.form.id, this.form)
      } else {
        this.$inertia.post('/admin/elementsdata', this.form)
      }
      this.form.show = false
      this.form.id = null
      this.form.label = ''
      this.form.satuan = ''
      this.form.is_published = false
      this.form.parent_id = 0
    },
    remove(row) {
      if (confirm('Takin untuk menghapus data ini?')) {
        this.$inertia.delete('/admin/elementsdata/' + row.id)
      }
    },
  },
}
</script>
